<template>
  <div>
    <h4 class="mt-2" :class="{ 'text--disabled': disabled }">{{ label }}</h4>
    <p v-if="isMarkdown" :class="{ 'text--disabled': disabled }" v-html="hint" />
    <p v-else :class="{ 'text--disabled': disabled }">{{ hint }}</p>
    <v-textarea v-model="inputValue" v-bind="$attrs" :disabled="disabled" @change="handleChange" />
  </div>
</template>

<script>
export default {
  props: {
    value: null,
    label: {
      type: String,
    },
    hint: {
      type: String,
    },
    isMarkdown: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      inputValue: this.value || null,
    };
  },
  watch: {
    value: {
      deep: true,
      handler(value) {
        this.inputValue = value;
      },
    },
  },
  methods: {
    handleChange() {
      this.$emit('input', this.inputValue);
    },
  },
};
</script>
